var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("account-verification-modal", {
        attrs: {
          "is-dialog-visible": _vm.isAccountVerificationModalVisible,
          "is-verification-override": false,
        },
        on: { visibilityChanged: _vm.setIsAccountVerificationModalVisible },
      }),
      _vm._v(" "),
      _c("account-verification-modal", {
        attrs: {
          "is-dialog-visible": _vm.isAccountVerificationOverrideModalVisible,
          "is-verification-override": true,
        },
        on: {
          visibilityChanged: _vm.setIsAccountVerificationOverrideModalVisible,
        },
      }),
      _vm._v(" "),
      _c("revoke-verification-modal", {
        attrs: { "is-dialog-visible": _vm.isAuthorizationRevokeModalVisible },
        on: { visibilityChanged: _vm.setIsAuthorizationRevokeModalVisible },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "ring-card-action-box grid gap-no" }, [
        _c("div", { staticClass: "span-1" }, [
          _c("img", {
            attrs: { src: _vm.icons.accountVerification, width: "32" },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "span-8" }, [
          _c(
            "div",
            {
              staticClass:
                "ring-card-action-box__text ring-card-action-box__title",
            },
            [_vm._v("\n        Account Verification\n      ")]
          ),
          _vm._v(" "),
          _vm.pii.authorization.status
            ? _c("div", [
                _c(
                  "div",
                  [
                    _vm._t("default", function () {
                      return [
                        _c("div", { staticClass: "flex flex-col" }, [
                          _c(
                            "div",
                            {
                              staticClass: "justify-between content-center",
                              staticStyle: { color: "#999999" },
                            },
                            [
                              _vm.pii.authorization.expires_at
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "ring-card-action-box__text ring-card-action-box__description",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Expires at:  \n                  "
                                      ),
                                      _c("time-zone-formatter", {
                                        attrs: {
                                          "current-time":
                                            _vm.pii.authorization.expires_at,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "ring-card-action-box__text ring-card-action-box__description",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Created at:\n                  "
                                      ),
                                      _c(
                                        "span",
                                        [
                                          _c("time-zone-formatter", {
                                            attrs: {
                                              "current-time":
                                                _vm.pii.authorization
                                                  .created_at,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                            ]
                          ),
                        ]),
                      ]
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-top": "12px" } }, [
            !_vm.pii.authorization.status
              ? _c(
                  "div",
                  {
                    staticClass:
                      "ring-card-action-box__text ring-card-action-box__text-error",
                  },
                  [_vm._v("\n          Verification Required\n        ")]
                )
              : _vm.pii.authorization.status === "active"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "ring-card-action-box__text-success ring-card-action-box__text",
                  },
                  [_vm._v("\n          Account Verified\n        ")]
                )
              : _c(
                  "div",
                  {
                    staticClass: "text-info",
                    staticStyle: { color: "orange" },
                  },
                  [
                    _vm._v(
                      "\n          Verification Status: " +
                        _vm._s(
                          _vm._f("sentenceCase")(_vm.pii.authorization.status)
                        ) +
                        "\n        "
                    ),
                  ]
                ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "span-3", class: _vm.verticalAlignment }, [
          _c("div", { staticClass: "customer-field" }, [
            !_vm.pii.authorization.status
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "custom-el-button",
                        staticStyle: { "margin-bottom": "10px" },
                        attrs: {
                          disabled:
                            _vm.disableVerifyAccount ||
                            _vm.isLocked ||
                            _vm.pii.authorization.status === "active",
                          size: "small",
                          type: "primary",
                          plain: "",
                        },
                        on: { click: _vm.showAccountVerificationModal },
                      },
                      [_vm._v("\n            Verify Account\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "LinkButton",
                      {
                        directives: [
                          {
                            name: "acl",
                            rawName: "v-acl.show",
                            value: {
                              permission: "overrideAuth",
                              on: "Customer",
                            },
                            expression:
                              "{permission: 'overrideAuth', on: 'Customer'}",
                            modifiers: { show: true },
                          },
                        ],
                        attrs: { disabled: _vm.disableVerifyAccount },
                        on: { click: _vm.showAccountOverrideVerificationModal },
                      },
                      [_vm._v("\n            Verify Override\n          ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.pii.authorization.status === "active"
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "custom-el-button",
                        staticStyle: { "margin-bottom": "10px" },
                        attrs: {
                          slot: "reference",
                          size: "small",
                          plain: "",
                          type: "primary",
                        },
                        on: { click: _vm.showRevokeAuthorizationModal },
                        slot: "reference",
                      },
                      [_vm._v("\n            Revoke Auth\n          ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }